import React, { useMemo } from 'react';
import styles from './DateRange.module.css';

export default function DateRange({
    label,
    value,
    onChange,
    withTime = false,
    enforceOrder = true,
    min,
    max,
    startPlaceholder = 'Start',
    endPlaceholder = 'End',
}) {
    const v = value || {};
    const start = v.start ?? '';
    const end = v.end ?? '';

    const type = withTime ? 'datetime-local' : 'date';

    const nextMinMax = useMemo(() => {
        const minEnd = start && enforceOrder ? start : min;
        const maxStart = end && enforceOrder ? end : max;
        return { minEnd, maxStart };
    }, [start, end, enforceOrder, min, max]);

    const setStart = (next) => {
        if (!enforceOrder || !end || next <= end) {
            onChange({ start: next, end });
        } else {
            onChange({ start: next, end: next });
        }
    };

    const setEnd = (next) => {
        if (!enforceOrder || !start || next >= start) {
            onChange({ start, end: next });
        } else {
            onChange({ start: next, end: next });
        }
    };

    return (
        <label className={styles.field}>
            <span className={styles.label}>{label}</span>
            <div className={styles.range}>
                <input
                    className={styles.input}
                    type={type}
                    value={start}
                    onChange={(e) => setStart(e.target.value)}
                    placeholder={startPlaceholder}
                    aria-label={`${label} start`}
                    min={min}
                    max={nextMinMax.maxStart}
                />
                <span className={styles.sep}>—</span>
                <input
                    className={styles.input}
                    type={type}
                    value={end}
                    onChange={(e) => setEnd(e.target.value)}
                    placeholder={endPlaceholder}
                    aria-label={`${label} end`}
                    min={nextMinMax.minEnd}
                    max={max}
                />
            </div>
        </label>
    );
}
